import React from "react";
import { KEY_ENTER, KEY_ESC } from "../../lib";
import styled from "styled-components";

const Input = styled.input`
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    outline: none;
    font-family: urdu, sans-serif;
    background-color: transparent;
`;

type Props = {
    value: string;
    onChange: (value: string) => void;
};
type State = {
    value: string;
    editable: boolean;
};

export class EditableText extends React.Component<Props, State> {
    private input: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);
        this.state = {
            value: "",
            editable: false,
        };

        this.input = React.createRef<HTMLInputElement>();
    }

    onClick = () => {
        this.setState(
            {
                editable: true,
                value: this.props.value,
            },
            () => {
                if (this.input && this.input.current) {
                    this.input.current.focus();
                }
            }
        );
    };

    onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            value: evt.target.value,
        });
    };

    onKeyUp = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if (evt.key === KEY_ENTER) {
            this.setState(
                {
                    editable: false,
                },
                () => this.props.onChange(this.state.value)
            );
        } else if (evt.key === KEY_ESC) {
            this.setState({
                editable: false,
                value: this.props.value,
            });
        }
    };

    render() {
        if (this.state.editable) {
            return (
                <div>
                    <Input
                        type="text"
                        value={this.state.value}
                        onKeyUp={this.onKeyUp}
                        onChange={this.onChange}
                        ref={this.input}
                    />
                </div>
            );
        }

        return <div onClick={this.onClick}>{this.props.value}</div>;
    }
}
